const addInfo = {
  title: 'Report',
  icon: 'report'
}
const reportRouter = {
  path: '/report',
  meta: {
    title: 'Report',
    icon: 'report',
    permission: ['reports']
  },
  children: [
    {
      path: 'report-list',
      component: () => import('@/views/report'),
      name: 'ReportList',
      meta: { title: 'Report', parent: addInfo, permission: ['reports'] },
    },
    {
      path: 'trips',
      hidden: true,
      meta: { title: 'Trips', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'all-vehicle-summary-report',
          component: () => import('@/views/report/Trips/all-vehicle-summary-report'),
          name: 'all_vehicle_summary_report',
          hidden: true
        },
        {
          path: 'monthly-vehicle-mileage-report',
          component: () => import('@/views/report/Trips/monthly-vehicle-mileage-report.vue'),
          name: 'monthly_vehicle_mileage_report',
          hidden: true
        },
        {
          path: 'vehicle-usage-report',
          component: () => import('@/views/report/Trips/vehicle-usage-report'),
          name: 'vehicle_usage_report',
          hidden: true
        },
        {
          path: 'trips-report',
          component: () => import('@/views/report/Trips/trips-report'),
          name: 'trips_report',
          hidden: true
        },
        {
          path: 'geofence-report',
          component: () => import('@/views/report/Trips/geofence-report'),
          name: 'geofence_report',
          hidden: true
        },
        {
          path: 'vehicle-drive-rest-report',
          component: () => import('@/views/report/Trips/vehicle-drive-rest-report'),
          name: 'vehicle_drive_rest_report',
          hidden: true
        },
        {
          path: 'driver-rest-report',
          component: () => import('@/views/report/DriverApp/driver-rest-report'),
          name: 'driver_rest_report',
          hidden: true
        },
        {
          path: 'poi-report',
          component: () => import('@/views/report/Trips/poi-report'),
          name: 'poi_report',
          hidden: true
        },
        {
          path: 'vehicle-journey-report',
          component: () => import('@/views/report/Trips/vehicle-journey-report'),
          name: 'vehicle_journey_report',
          hidden: true
        },
      ]
    },
    {
      path: 'vehicle-performance',
      hidden: true,
      meta: { title: 'VehiclePerformance', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'vehicle-status-log',
          component: () => import('@/views/report/VehiclePerformance/vehicle-status-log'),
          name: 'vehicle_status_log',
          hidden: true
        },
        {
          path: 'machinery-summary-report',
          component: () => import('@/views/report/VehiclePerformance/machinery-summary-report'),
          name: 'machinery_summary_report',
          hidden: true
        },
        {
          path: 'vehicle_service_log_report',
          component: () => import('@/views/report/VehiclePerformance/vehicle_service_log_report'),
          name: 'vehicle_service_log_report',
          hidden: true
        },
        {
          path: 'idling-summary-report',
          component: () => import('@/views/report/VehiclePerformance/idling-summary-report'),
          name: 'idling_summary_report',
          hidden: true
        },
        {
          path: 'monthly-idling-summary-report-by-geofence-category',
          component: () => import('@/views/report/VehiclePerformance/monthly-idling-summary-report-by-geofence-category'),
          name: 'monthly_idling_summary_report_by_geofence_category',
          hidden: true
        },
        {
          path: 'raw-data-report',
          component: () => import('@/views/report/VehiclePerformance/raw-data-report'),
          name: 'raw_data_report',
          hidden: true
        },
        {
          path: 'pto-log',
          component: () => import('@/views/report/VehiclePerformance/pto-log'),
          name: 'pto_log',
          hidden: true
        },
        {
          path: 'engine-report',
          component: () => import('@/views/report/VehiclePerformance/engine-report'),
          name: 'engine_report',
          hidden: true
        },
        {
          path: 'temperature-report',
          component: () => import('@/views/report/ColdChain/temperature-report'),
          name: 'temperature_report',
          hidden: true
        },
        {
          path: 'pto-camera-report',
          component: () => import('@/views/report/VehiclePerformance/pto-camera-report'),
          name: 'pto_camera_report',
          hidden: true
        },
        {
          path: 'rotation-report',
          component: () => import('@/views/report/VehiclePerformance/rotation-report'),
          name: 'rotation_report',
          hidden: true
        },
        {
          path: 'driving-record-report',
          component: () => import('@/views/report/VehiclePerformance/driving-record-report'),
          name: 'driving_record_report',
          hidden: true
        },
      ]
    },
    {
      path: 'trailer',
      hidden: true,
      meta: { title: 'Trailer', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'trailer-log-report',
          component: () => import('@/views/report/Trailer/trailer-log-report'),
          name: 'trailer_log_report',
          hidden: true
        },
        {
          path: 'trailer-raw-report',
          component: () => import('@/views/report/Trailer/trailer-raw-report'),
          name: 'trailer_raw_report',
          hidden: true
        }
      ]
    },
    {
      path: 'driver',
      hidden: true,
      meta: { title: 'Driver', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'driver-summary-report',
          component: () => import('@/views/report/Driver/driver-summary-report'),
          name: 'driver_summary_report',
          hidden: true
        },
        {
          path: 'driver-logs-report',
          component: () => import('@/views/report/Driver/driver-logs-report'),
          name: 'driver_logs_report',
          hidden: true
        },
        {
          path: 'driver-trips-report',
          component: () => import('@/views/report/Driver/driver-trips-report'),
          name: 'driver_trips_report',
          hidden: true
        },
        {
          path: 'driver-activity-report',
          component: () => import('@/views/report/Driver/driver-activity-report'),
          name: 'driver_activity_report',
          hidden: true,
        },
        {
          path: 'driver-activity-summary-report',
          component: () => import('@/views/report/Driver/driver-activity-summary-report'),
          name: 'driver_activity_summary_report',
          hidden: true
        },
        {
          path: 'driver-violation-report',
          component: () => import('@/views/report/Driver/driver-violation-report.vue'),
          name: 'driver_violation_report',
          hidden: true
        },
        {
          path: 'driver-debriefing-report',
          component: () => import('@/views/report/Driver/driver-debriefing-report.vue'),
          name: 'driver_debriefing_report',
          hidden: true
        },
        {
          path: 'driver-trip-summary-report',
          component: () => import('@/views/report/Driver/driver-trip-summary-report.vue'),
          name: 'driver_trip_summary_report',
          hidden: true
        },
        {
          path: 'driver-unauthorized-stop-report',
          component: () => import('@/views/report/Driver/driver-unauthorized-stop-report.vue'),
          name: 'driver_unauthorized_stop_report',
          hidden: true
        },
        {
          path: 'driver-driving-behaviour-violation-report',
          component: () => import('@/views/report/Driver/driver-driving-behaviour-violation-report.vue'),
          name: 'driver_driving_behaviour_violation_report',
          hidden: true
        },
      ]
    },
    {
      path: 'advanced-safety',
      hidden: true,
      meta: { title: 'AdvancedSafety', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'driver-violation-report',
          component: () => import('@/views/report/Driver/driver-violation-report.vue'),
          name: 'driver_violation_report',
          hidden: true
        },
        {
          path: 'driver-debriefing-report',
          component: () => import('@/views/report/Driver/driver-debriefing-report.vue'),
          name: 'driver_debriefing_report',
          hidden: true
        },
        {
          path: 'driver-trip-summary-report',
          component: () => import('@/views/report/Driver/driver-trip-summary-report.vue'),
          name: 'driver_trip_summary_report',
          hidden: true
        },
        {
          path: 'driver-unauthorized-stop-report',
          component: () => import('@/views/report/Driver/driver-unauthorized-stop-report.vue'),
          name: 'driver_unauthorized_stop_report',
          hidden: true
        },
        {
          path: 'driver-driving-behaviour-violation-report',
          component: () => import('@/views/report/Driver/driver-driving-behaviour-violation-report.vue'),
          name: 'driver_driving_behaviour_violation_report',
          hidden: true
        },
      ]
    },
    {
      path: 'driver-app',
      hidden: true,
      meta: { title: 'DriverApp', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'driver-job-report',
          component: () => import('@/views/report/DriverApp/driver-job-report'),
          name: 'driver_job_report',
          hidden: true
        },
        {
          path: 'checklist-log',
          component: () => import('@/views/report/DriverApp/checklist-log'),
          name: 'checklist_log',
          hidden: true
        },
        {
          path: 'get-checklist-report',
          component: () => import('@/views/report/DriverApp/get-checklist-report'),
          name: 'checklist_report',
          hidden: true
        },
        {
          path: 'view-checklist-report-details/:id?',
          component: () => import('@/views/report/DriverApp/view-checklist-report-details'),
          name: 'view_checklist_report_details',
          hidden: true
        }
      ]
    },
    {
      path: 'safety',
      hidden: true,
      meta: { title: 'Safety', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'vehicle-safety-report',
          component: () => import('@/views/report/Safety/vehicle-safety-report'),
          name: 'vehicle_safety_report',
          hidden: true
        },
        {
          path: 'fatigue-photo-video-report',
          component: () => import('@/views/report/Safety/fatigue-photo-video-report'),
          name: 'fatigue_photo_video_report',
          hidden: true
        },
        {
          path: 'fatigue-monitor-board',
          component: () => import('@/views/report/Safety/fatigue-monitor-board'),
          name: 'fatigue_monitor_board',
          hidden: true
        },
        {
          path: 'fatigue-driving-record/:id',
          component: () => import('@/views/report/Safety/fatigue-driving-record'),
          name: 'fatigue_driving_record',
          hidden: true
        },
      ]
    },
    {
      path: 'spend',
      hidden: true,
      meta: { title: 'Spend', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'toll-report',
          component: () => import('@/views/report/Spend/toll-report'),
          name: 'toll_report',
          hidden: true
        },
      ]
    },
    {
      path: 'fuel',
      hidden: true,
      meta: { title: 'Fuel', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'fuel-drop-report',
          component: () => import('@/views/report/Fuel/fuel-drop-report'),
          name: 'fuel_drop_report',
          hidden: true
        },
        {
          path: 'refuel-summary-report',
          component: () => import('@/views/report/Fuel/refuel-summary-report'),
          name: 'refuel_summary_report',
          hidden: true
        },
        {
          path: 'mileage-liter-by-statement',
          component: () => import('@/views/report/Fuel/mileage-liter-by-statement'),
          name: 'mileage_liter_by_statement',
          hidden: true
        },
      ]
    },
    {
      path: 'esg',
      hidden: true,
      meta: { title: 'ESG', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'esg-monthly-report',
          component: () => import('@/views/report/ESG/esg-monthly-report'),
          name: 'esg_monthly_report',
          hidden: true
        },
        {
          path: 'esg-report',
          component: () => import('@/views/report/ESG/esg-detail-report'),
          name: 'esg_report',
          hidden: true
        },
        {
          path: 'vehicle-monthly-esg-performance-report',
          component: () => import('@/views/report/ESG/vehicle-monthly-esg-performance-report'),
          name: 'vehicle_monthly_esg_performance_report',
          hidden: true
        }
      ]
    },
    {
      path: 'operator',
      hidden: true,
      meta: { title: 'Operator', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'operator-company-daily-report',
          component: () => import('@/views/report/Operator/operator-company-daily-report'),
          name: 'operator_company_daily_report',
          hidden: true
        },
        {
          path: 'operator-attendance-report',
          component: () => import('@/views/report/Operator/operator-attendance-report'),
          name: 'operator_attendance_report',
          hidden: true
        },
        {
          path: 'operator-driver-report',
          component: () => import('@/views/report/Operator/operator-driver-report'),
          name: 'operator_driver_report',
          hidden: true
        },
      ]
    },
    {
      path: 'alert',
      hidden: true,
      meta: { title: 'Alert', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'suspicious-activity-report',
          component: () => import('@/views/report/Alert/suspicious-activity-report'),
          name: 'suspicious_activity_report',
          hidden: true
        },
        {
          path: 'critical-alert-report',
          component: () => import('@/views/report/Alert/critical-alert-report'),
          name: 'critical_alert_report',
          hidden: true
        },
        {
          path: 'alert-report',
          component: () => import('@/views/report/Alert/alert-report'),
          name: 'alert_report',
          hidden: true
        },
        {
          path: 'maintenance-alert-report',
          component: () => import('@/views/report/Alert/maintenance-alert-report'),
          name: 'maintenance_alert_report',
          hidden: true
        },
      ]
    },
    {
      path: 'diagnosis',
      hidden: true,
      meta: { title: 'Diagnosis', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'vehicle-diagnosis-report',
          component: () => import('@/views/report/Diagnosis/vehicle-diagnosis-report'),
          name: 'vehicle_diagnosis_report',
          hidden: true
        },
      ]
    },
    {
      path: 'speed',
      hidden: true,
      meta: { title: 'Speed', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'speed-report',
          component: () => import('@/views/report/Speed/speed-report'),
          name: 'speed_report',
          hidden: true
        },
        {
          path: 'overspeed-report',
          component: () => import('@/views/report/Speed/overspeed-report'),
          name: 'overspeed_report',
          hidden: true
        },
      ]
    },
    {
      path: 'route',
      hidden: true,
      meta: { title: 'Route', parent: addInfo, activeMenu: '/report/report-list' },
      children: [
        {
          path: 'route-deviation-violation-report',
          component: () => import('@/views/report/Route/route-deviation-violation-report'),
          name: 'route_deviation_violation_report',
          hidden: true
        },
      ]
    }
  ]
}

export default reportRouter
